<template>
<button @click="$emit('click')">
  <svg version="1.1" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveaspectratio>
    <line x1="0" y1="0%" x2="100%" y2="100%" stroke="currentColor" stroke-width="1" />
    <line x1="0" y1="100%" x2="100%" y2="0%" stroke="currentColor" stroke-width="1" />
  </svg>
</button>
</template>

<script>
export default {
  name: 'CloseIcon'
}
</script>

<style lang="scss" scoped>
@import '../style/variables';

button{
  display:block;
  width:1.25rem; // (29px/30px*$rem);
  height:1.25rem;
}
svg{
  display:block;
  width:100%;
}
  
</style>



// WEBPACK FOOTER //
// IconClose.vue?45f6d715